// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';
import { Grid, Box, Typography, Card } from '@mui/material';

import Logo from '@/layouts/full/shared/logo/Logo';

import AuthForgotPassword from '@/components/authForms/AuthForgotPassword';
import { useTranslation } from '@/hooks/useTranslation';

const ForgotPassword = () => {
  const { t } = useTranslation();
  
  return (
  <Box
    sx={{
      position: 'relative',
      '&:before': {
        content: '""',
        background: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
        backgroundSize: '400% 400%',
        animation: 'gradient 15s ease infinite',
        position: 'absolute',
        height: '100%',
        width: '100%',
        opacity: '0.3',
      },
    }}
  >
    <Grid container spacing={0} justifyContent="center" sx={{ height: '100vh' }}>
      <Grid
        display="flex"
        justifyContent="center"
        alignItems="center"
        size={{
          xs: 12,
          sm: 12,
          lg: 4,
          xl: 3,
        }}>
        <Card elevation={9} sx={{ p: 4, zIndex: 1, width: '100%', maxWidth: '500px' }}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Logo />
          </Box>
          <Typography
            color="textSecondary"
            textAlign="center"
            variant="subtitle2"
            fontWeight="400"
            mt={4}
          >
            {t('forgotPassword.description')}
          </Typography>
          <AuthForgotPassword />
        </Card>
      </Grid>
    </Grid>
  </Box>
  );
};

export default ForgotPassword;
